import { VersionManager } from "../utils/VersionManager";
VersionManager.run();

import { registerSW } from "virtual:pwa-register";

import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "../index.css";
import { installBackendAuthFetch } from "../utils/backendAuthFetch";

// Anexa o login do usuario as chamadas ao servidor Python (auditoria de seguranca 21/09/2026).
installBackendAuthFetch();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000,
      refetchOnWindowFocus: false,
    },
  },
});

// --- REGISTRO PWA COM AUTO-RELOAD ---
registerSW({ immediate: true });

// --- GHOST KILLER PROTOCOL V2 (força reload após matar SW) ---
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    if (registrations.length === 0) {
      try {
        sessionStorage.removeItem("_rda_ghost_reloaded");
      } catch {}
      return;
    }
    const alreadyReloaded = (() => {
      try {
        return sessionStorage.getItem("_rda_ghost_reloaded") === "1";
      } catch {
        return false;
      }
    })();
    if (alreadyReloaded) return;
    Promise.all(
      registrations.map((r) => {
        console.warn("[Ghost Killer] Desregistrando Service Worker Zumbi:", r);
        return r.unregister();
      }),
    ).then(() => {
      try {
        sessionStorage.setItem("_rda_ghost_reloaded", "1");
      } catch {}
      window.location.reload();
    });
  });
}
// -------------------------------------------------------------

let booted = false;

const init = () => {
  if (booted) return;
  const rootElement = document.getElementById("root");
  if (!rootElement) return;
  booted = true;

  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
};

// FIX 4 — Office.js Isolation: carrega o script dinamicamente APENAS quando o app
// está rodando dentro de um iframe (contexto do Word Add-in / Taskpane).
// Usuários do portal web nunca carregam o script → elimina o warning
// "Office.js is loaded outside of Office client" em todas as rotas do portal.
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

if (isInIframe) {
  const officeScript = document.createElement("script");
  officeScript.src =
    "https://appsforoffice.microsoft.com/lib/1/hosted/office.js";
  officeScript.onload = () => {
    const office = window?.Office;
    if (office && typeof office.onReady === "function") {
      try {
        const p = office.onReady();
        if (p && typeof p.then === "function") {
          p.then(() => {
            console.log("[RDA Bridge] Office conectado.");
            init();
          }).catch(() => init());
        } else {
          office.onReady(() => {
            console.log("[RDA Bridge] Office conectado.");
            init();
          });
        }
      } catch {
        init();
      }
    } else {
      init();
    }
  };
  officeScript.onerror = () => init();
  document.head.appendChild(officeScript);
} else {
  init();
}
